export default __webpack_public_path__ + "static/media/vili_l.5e5b3df0.jpg";